import { Node } from '@tiptap/core'

export const PhraseToken = Node.create({
  name: 'phrase_token',

  inline: true,
  group: 'inline',
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      phrase: { default: null },   // mynormalexam
      label: { default: null },    // .mynormalexam
    }
  },

  parseHTML() {
    return [{ tag: 'phrase-token' }]
  },

  renderHTML({ node }) {
    return [
      'phrase-token',
      {
        'data-phrase': node.attrs.phrase,
        class: 'chart_phrase_token',
      },
      node.attrs.label,
    ]
  },
})
